module.exports = __webpack_public_path__ + "img/A4.f46d8aba.png";